// test1876
(1876 && 0);
